import { actionTypes } from "../Actions/default.action"

const initialState = {
  modelList: {
    data: [],
  },
  model: {},
  success: false,
  error: {},
}

// eslint-disable-next-line
export default (state = initialState, { type, payLoad }) => {
  switch (type) {
    case actionTypes.INDEX:
      return {    ...state,
        modelList: {
          ...state.modelList,
          data: payLoad,
        },};
    case actionTypes.DESTROY:
      return {
        ...state,
        modelList: {
          ...state.modelList,
          data: state.modelList.data.filter((item) => item.id !== payLoad),
        },
      };
    case actionTypes.CHANGE:
      return {
        ...state,
        model: {
          ...state.group,
          ...payLoad,
        },
      };
    case actionTypes.SUCCESS:
      return { ...state, success: payLoad };
    case actionTypes.ERROR:
      return {
        ...state,
        error: payLoad,
      };
    default:
      return state;
  }
};
